import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { LoadingBlock } from "@/components/AsyncState";

const ProfilePage = lazy(() => import("@/pages/ProfilePage"));

function ProfileFallback() {
  return (
    <div className="relative px-5 pt-14">
      <LoadingBlock label="Loading profile…" />
    </div>
  );
}

function ProfileRoute() {
  return (
    <Suspense fallback={<ProfileFallback />}>
      <ProfilePage />
    </Suspense>
  );
}

export const Route = createFileRoute("/profile")({
  validateSearch: (search: Record<string, unknown>) => {
    const tab = search.tab;
    return {
      tab:
        tab === "tonight" || tab === "memories" || tab === "friends"
          ? (tab as "tonight" | "memories" | "friends")
          : undefined,
    };
  },
  head: () => ({
    meta: [
      { title: "Profile · Pulse" },
      { name: "description", content: "Your saved events, memories and friends." },
    ],
  }),
  component: ProfileRoute,
});
